//RobObject
export const robots = [
  {
    id: 1,
    name: 'Galileo ',
    username: 'Bret',
    email: 'g@80bits.com'
  },
  {
    id: 2,
    name: 'Jade',
    username: 'Antonette',
    email: 'mons.jade@gmail.com'
  },
  {
    id: 3,
    name: 'Andrés ',
    username: 'Samantha',
    email: 'info@guigo.com.mx'
  },
  {
    id: 4,
    name: 'Joséphine ',
    username: 'Karianne',
    email: 'chepina@bebe.com'
  },
  {
    id: 5,
    name: 'Joffrey',
    username: 'Kamren',
    email: 'medecin@lareunnion.fr'
  },
  {
    id: 6,
    name: 'Mireille',
    username: 'Leopoldo_Corkery',
    email: '´mireille.mons@bureau.info'
  },
  {
    id: 7,
    name: 'Severine',
    username: 'Elwyn.Skiles',
    email: 'sev@ingenieur.biz'
  },
  {
    id: 8,
    name: 'Huguette Tachon',
    username: 'Maxime_Nienow',
    email: 'gueguette@jardins.me'
  },
  {
    id: 9,
    name: 'Hervé',
    username: 'Delphine',
    email: 'fromagerie@mons.com'
  },
  {
    id: 10,
    name: 'Aníbal',
    username: 'Moriah.Stanton',
    email: 'pichi@chiapas.biz'
  },
  {
    id: 11,
    name: 'Mireya',
    username: 'Moriah.Stanton',
    email: 'mire@chiapas.biz'
  },
  {
    id: 12,
    name: 'Diana',
    username: 'Moriah.Stanton',
    email: 'diani@doctora.biz'
  },
  {
    id: 13,
    name: 'Sofía',
    username: 'Moriah.Stanton',
    email: 'sofia@carranza.biz'
  },
  {
    id: 14,
    name: 'Arbey',
    username: 'Moriah.Stanton',
    email: 'arbey@leal.io'
  },
  {
    id: 15,
    name: 'Alfredo',
    username: 'Moanton',
    email: 'chepe@hidalgo.io'
  },
  {
    id: 16,
    name: 'Maco',
    username: 'Stanton',
    email: 'maco@vergel.io'
  },
  {
    id: 17,
    name: 'Fabiola',
    username: '.Stanton',
    email: 'fabi@primavera.io'
  }
];
